<template>
  <div id="directors">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">Directors</div>
          <div slot="subtitle">CURRENT OPEN DIRECTORSHIPS AT THIS COMPANY.</div>
        </section-heading>
      </div>
    </div>
    <div class="row" v-if="report.companyoverview.officers.length === 0">
      <div class="well well-sm well-neutral">
        <table class="table-condensed">
          <tbody>
            <tr>
              <td width="50" style="text-align: center">
                <i class="fas fa-exclamation-circle"></i>
              </td>
              <td>
                <h4>Director information not available for this company</h4>
                <p>
                  We are unable to find any active directors for this company, this could be for a
                  number of reasons including that the business was only recently incorporated.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div v-for="officer in report.companyoverview.officers" :key="officer.id">
          <director
            :diff-data="diffData"
            :officer="officer"
            :report="report"
            :show-diff="showDiff"
          />
        </div>
      </div>
    </div>
    <div class="sectionBreak row"></div>
  </div>
</template>

<script>
import SectionHeading from '@/components/reports/components/SectionHeading';
import Director from '@/components/reports/panels/Director';

export default {
  components: {
    SectionHeading,
    Director,
  },
  props: ['report', 'showDiff', 'diffData'],
};
</script>
